import { render } from "./AddMainEngineEnergySavingsComponent.vue?vue&type=template&id=0daa9f1a&scoped=true"
import script from "./AddMainEngineEnergySavingsComponent.vue?vue&type=script&lang=js"
export * from "./AddMainEngineEnergySavingsComponent.vue?vue&type=script&lang=js"

import "./AddMainEngineEnergySavingsComponent.vue?vue&type=style&index=0&id=0daa9f1a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daa9f1a"]])

export default __exports__